import { getPrivateKey, savePrivateKey, clearPrivateKey } from './secureKeyVault';

function legacyStorageKey(userId: string) {
  return `e2e_private_key_${userId}`;
}

async function importLegacyPrivateKey(base64: string): Promise<CryptoKey> {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

  return crypto.subtle.importKey(
    'pkcs8',
    bytes.buffer,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    true,
    ['decrypt']
  );
}

export async function migrateLegacyPrivateKey(userId: string): Promise<{ migrated: boolean; key: CryptoKey | null }> {
  const existingVaultKey = await getPrivateKey(userId);
  if (existingVaultKey) {
    return { migrated: false, key: existingVaultKey };
  }

  const legacy = localStorage.getItem(legacyStorageKey(userId));
  if (!legacy) {
    return { migrated: false, key: null };
  }

  try {
    const imported = await importLegacyPrivateKey(legacy);
    await savePrivateKey(userId, imported);
    return { migrated: true, key: imported };
  } catch (error) {
    console.error('[KEY-MIGRATION] Failed to import legacy private key', error);
    return { migrated: false, key: null };
  }
}

export async function cleanupLegacyPrivateKey(userId: string) {
  localStorage.removeItem(legacyStorageKey(userId));
}

export async function resetAllPrivateKeyMaterial(userId: string) {
  await clearPrivateKey(userId);
  localStorage.removeItem(legacyStorageKey(userId));
}
